import useConfirmationSubmit from '../hooks/useConfirmationSubmit';
import '../CSS/pages.css';

function DedicatedLanes() {
  const { handleSubmit, isSubmitting, submitError } = useConfirmationSubmit(
    'dedicatedLanes',
    'dedicated lanes support'
  );

  return (
    <main className="page service-page">
      <section className="page-heading">
        <p className="eyebrow">Dedicated lanes</p>
        <h1>Consistent route planning for dependable freight movement.</h1>
        <p>
          Build around preferred lanes, backhaul opportunities, and steady route
          expectations so your operation can plan with more confidence week to
          week.
        </p>
      </section>

      <section className="contact-layout">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" name="name" placeholder="Your name" required />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>
          <label>
            Phone number
            <input type="tel" name="phone" placeholder="(555) 000-0000" required />
          </label>
          <label>
            Equipment type
            <select name="equipmentType" defaultValue="" required>
              <option value="" disabled>
                Select equipment type
              </option>
              <option value="dry-van">Dry van</option>
              <option value="reefer">Reefer</option>
              <option value="flatbed">Flatbed</option>
              <option value="step-deck">Step deck</option>
              <option value="box-truck">Box truck</option>
              <option value="power-only">Power only</option>
              <option value="hotshot">Hotshot</option>
            </select>
          </label>
          <label>
            Message
            <textarea
              name="message"
              rows="5"
              placeholder="Tell us about your lanes, route goals, schedule, or dispatch needs"
              required
            />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Request dedicated lane support'}
          </button>
          {submitError && <p className="form-error">{submitError}</p>}
        </form>

        <aside className="contact-panel">
          <h2>What this service covers</h2>
          <p>
            Route-focused dispatch planning for carriers who want predictable
            lanes, stronger backhaul options, and dependable weekly movement.
          </p>
          <ul>
            <li>Preferred lane planning</li>
            <li>Backhaul opportunity review</li>
            <li>Schedule and availability coordination</li>
            <li>Consistent route support</li>
          </ul>
        </aside>
      </section>
    </main>
  );
}

export default DedicatedLanes;
